module.exports = __webpack_public_path__ + "img/play.419f7a93.svg";